import strapi, { mapStrapiData } from '../lib/strapi';

export const getJourneyPageData = async () => {
  try {
    const pageRes = await strapi.get('/our-journey-page?populate=*');
    const projectsRes = await strapi.get('/projects?populate=*&sort=createdAt:desc');

    return {
      content: mapStrapiData(pageRes),
      projects: projectsRes.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching Journey data:', error);
    return null;
  }
};